const ns = {};

ns.UrlHelper = function () {};

/**
 * Builds a query for get parameters in the url. All values will be encoded.
 * Because we have to use the window.location object, the page will be reloaded after calling this method.
 *
 * @param {Object} parameters A key-value-object. E.g. {profileId: 123, testString: 'This is a test'}
 * @param {Boolean} traditional A Boolean indicating whether to perform a traditional "shallow" serialization (@see http://api.jquery.com/jquery.param/)
 */
ns.UrlHelper.prototype.buildQuery = function (parameters, traditional) {
    traditional = typeof traditional === 'undefined' ? false : traditional;

    var encodedParams = {};
    $.each(parameters, function(key, value) {
        encodedParams[key] = encodeURIComponent(value);
    });

    window.location.search = '?' + $.param(encodedParams, traditional);
};

/**
 * Removes all queries from the url (but not the hash). After this, the page is reloading because we have to use the window.location object.
 */
ns.UrlHelper.prototype.removeQuery = function () {
    window.location = window.location.pathname + window.location.hash;
};

/**
 * Gets a Parameter value from the url.
 * @see http://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js/21903119#21903119
 *
 * @param {String} parameter The key of the GET-parameter.
 * @returns {String} The value of the given parameter or an empty string if the key has no value (e.g. ?test#abc) or if it is not found.
 */
ns.UrlHelper.prototype.getParameterValue = function (parameter) {
    var sPageUrl = decodeURIComponent(window.location.search.substring(1)),
        sUrlVariables = sPageUrl.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sUrlVariables.length; i++) {
        sParameterName = sUrlVariables[i].split('=');

        if (sParameterName[0] === parameter) {
            return sParameterName[1] === undefined ? '' : sParameterName[1];
        }
    }
    return '';
};

export default ns.UrlHelper;
